import { isDefined } from '@adornis/buchungsheld-db/util.js';
import '@adornis/buchungsheld-theme/components/tr-button-small.js';
import '@adornis/buchungsheld-theme/components/tr-checkbox.js';
import '@adornis/buchungsheld-theme/components/tr-chip.js';
import '@adornis/buchungsheld-theme/components/tr-data-view.js';
import '@adornis/buchungsheld-theme/components/tr-icon.js';
import '@adornis/buchungsheld-theme/components/tr-tooltip.js';
import '@adornis/buchungsheld-theme/fonts/fonts.js';
import { ChemistryLitElement } from '@adornis/chemistry/chemistry-lit-element.js';
import { acss } from '@adornis/chemistry/directives/acss.js';
import { css } from '@adornis/chemistry/directives/css.js';
import '@adornis/chemistry/elements/components/x-button.js';
import '@adornis/chemistry/elements/components/x-card.js';
import '@adornis/chemistry/elements/components/x-flex.js';
import '@adornis/chemistry/elements/components/x-icon.js';
import '@adornis/dragdrop/x-drag-drop.js';
import '@adornis/filter/client/x-filter-editor.js';
import '@adornis/popover/x-dropdown.js';
import type { XDropdown } from '@adornis/popover/x-dropdown.js';
import { html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import type { Ref } from 'lit/directives/ref.js';

export type ActionItem = {
  icon: string;
  text: string;
  disabled?: boolean;
  action: () => Promise<void>;
};

@customElement('bh-dropdown-action-content')
export class BhDropdownActionContent extends ChemistryLitElement {
  @property() heading!: string;
  @property({ attribute: false }) actions!: () => ActionItem[];
  @property({ attribute: false }) dialogRef?: Ref<XDropdown>;

  override render() {
    if (!this.dialogRef?.value?.isOpen())
      return 'dialog is closed, render nothing. If you see this something went wrong';

    const actions = this.actions();
    const items = actions
      .filter(isDefined)
      .map(c => ({ ...c, disabled: (c as any).disabled ?? false }))
      .map(
        ({ icon, text, disabled, action }) => html`
          <x-flex horizontal crossaxis-center item space="xs" ?disabled=${disabled} @click=${() => action()}>
            <x-icon> ${icon} </x-icon>
            <x-text> ${text} </x-text>
          </x-flex>
        `,
      );

    return html`
      <x-card
        ${acss({
          '[item]': {
            cursor: 'pointer',
            padding: `${this.spacing.xs} ${this.spacing.md}`,
            '&:hover': { background: this.colors.neutral.shade(100) },
          },
        })}
      >
        <x-text ${css({ fontWeight: 'bold' })}>
          ${actions.length > 0 ? this.heading : 'Keine Aktionen verfügbar'}
        </x-text>

        ${(() => {
          if (actions.length === 0) return nothing;
          return html`
            <x-flex
              ${css({
                height: '1px',
                width: '100%',
                background: this.colors.secondary.shade(100),
              })}
            ></x-flex>

            <x-flex ${css({ marginLeft: `-${this.spacing.md}`, marginRight: `-${this.spacing.md}` })}>
              ${actions.length > 0
                ? items
                : html`<x-flex horizontal crossaxis-center> <x-text> ${'Keine Aktionen verfügbar'} </x-text> </x-flex>`}
            </x-flex>
          `;
        })()}
      </x-card>
    `;
  }
}
